export const typesCotizacion = {
  dataLoading: "[cotizacion] Cotizaciones data Loading",
  cotizacionesLoaded: "[cotizacion] Cotizaciones Loaded",
  cotizacionSetActive: "[cotizacion] cotizacion Set Active",
  cotizacionClearActive: "[cotizacion] cotizacion Clear Active",
  detalleCotizacionSetActive: "[cotizacion] detalle cotizacion Set Active",
  detalleCotizacionClearActive: "[cotizacion] detalle cotizacion Clear Active",
  cotizacionAdded: "[cotizacion] cotizacion added",
  cotizacionUpdated: "[cotizacion] cotizacion updated",
  cotizacionDeleted: "[cotizacion] cotizacion deleted",
  cotizacionLogout: "[cotizacion] cotizacion logout",
};
